import { Navigate, Outlet } from "react-router-dom";
import { defaultPathForRole } from "../../js/auth/packageAccess";
import { hasAgentAccess, hasBrokerAccess } from "../../js/auth/authService";
import { useAuth } from "../../js/hooks/useAuth";
import RequirePackageDesk from "./RequirePackageDesk";

/**
 * Role isolation: signed-in users stay on the desk for their account type.
 * Guests may browse buyer and seller journeys (view-only elsewhere).
 */
function renderDesk(content) {
  return content ?? <Outlet />;
}

export default function RequireRoleDesk({ desk, children, allowGuest = true }) {
  const { role } = useAuth();

  if (!role && allowGuest) {
    return <RequirePackageDesk desk={desk}>{renderDesk(children)}</RequirePackageDesk>;
  }

  if (role === "admin") return renderDesk(children);

  if (desk === "buyer") {
    if (role === "buyer") {
      return <RequirePackageDesk desk="buyer">{renderDesk(children)}</RequirePackageDesk>;
    }
    if (role === "seller") return <Navigate to="/seller/home" replace />;
    if (hasAgentAccess(role)) return <Navigate to={defaultPathForRole(role)} replace />;
    if (hasBrokerAccess(role)) return <Navigate to={defaultPathForRole(role)} replace />;
  }

  if (desk === "seller") {
    if (role === "seller") {
      return <RequirePackageDesk desk="seller">{renderDesk(children)}</RequirePackageDesk>;
    }
    if (role === "buyer") return <Navigate to="/start" replace />;
    if (hasAgentAccess(role)) return <Navigate to={defaultPathForRole(role)} replace />;
    if (hasBrokerAccess(role)) return <Navigate to={defaultPathForRole(role)} replace />;
  }

  return <Navigate to="/" replace />;
}
